import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import Select from 'react-select';
import PropTypes from 'prop-types';
import copyTextToClipboard from '../../clipboardUtils';
import { postRequest } from '../../requestUtils';
import ModalTrigger from '../common/ModalTrigger';
import DropdownIndicator from '../common/DropdownIndicator';
import dropdownStyleUtils from '../../dropdownStyleUtils';
import copyLinkImg from '../../../assets/images/link-green.svg';
import './ShareResource.scss';
var ShareResource = /*#__PURE__*/function (_Component) {
  function ShareResource(props) {
    var _this;
    _classCallCheck(this, ShareResource);
    _this = _callSuper(this, ShareResource, [props]);
    _this.state = {
      errors: '',
      recipient: props.recipientOptions[0],
      skipScreening: false,
      copying: false,
      copyFailed: false,
      url: '',
      source: ''
    };
    _this.copyResetTimer = null;
    _this.handleToggleScreening = _this.handleToggleScreening.bind(_this);
    _this.handleGenerate = _this.handleGenerate.bind(_this);
    _this.handleCopy = _this.handleCopy.bind(_this);
    return _this;
  }
  _inherits(ShareResource, _Component);
  return _createClass(ShareResource, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.copyResetTimer);
    }
  }, {
    key: "handleGenerate",
    value: function handleGenerate(callback) {
      var _this2 = this;
      var _this$props = this.props,
        generateUrl = _this$props.generateUrl,
        csrfToken = _this$props.csrfToken,
        resourceId = _this$props.resourceId;
      var _this$state = this.state,
        source = _this$state.source,
        recipient = _this$state.recipient,
        skipScreening = _this$state.skipScreening;
      var linkType = recipient.value === 'employers' ? 'employer' : "consultant_".concat(skipScreening ? 'sourced' : 'plain');
      var data = {
        resource_id: resourceId,
        link_type: linkType
      };
      if (source) data.candidate_source = source.value;
      return postRequest(generateUrl, data, csrfToken).then(function (response) {
        _this2.setState({
          url: response.data.url,
          errors: ''
        }, callback);
      })["catch"](function (err) {
        _this2.setState({
          errors: err
        });
      });
    }
  }, {
    key: "handleToggleScreening",
    value: function handleToggleScreening(e) {
      var skipScreening = this.state.skipScreening;
      e.preventDefault();
      this.setState({
        skipScreening: !skipScreening
      }, this.getUrl);
    }
  }, {
    key: "linkIsDisabled",
    value: function linkIsDisabled() {
      var _this$state2 = this.state,
        recipient = _this$state2.recipient,
        source = _this$state2.source;
      return !(recipient.value === 'employers' || recipient && source);
    }
  }, {
    key: "handleCopy",
    value: function () {
      var _handleCopy = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this3 = this;
        var url, success;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = this.state.url;
              _context.next = 3;
              return copyTextToClipboard(url);
            case 3:
              success = _context.sent;
              this.setState({
                copying: success,
                copyFailed: !success
              });
              clearTimeout(this.copyResetTimer);
              this.copyResetTimer = setTimeout(function () {
                _this3.setState({
                  copying: false,
                  copyFailed: false
                });
              }, success ? 1500 : 3000);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleCopy() {
        return _handleCopy.apply(this, arguments);
      }
      return handleCopy;
    }()
  }, {
    key: "copyLabel",
    value: function copyLabel(defaultLabel) {
      var _this$state3 = this.state,
        copying = _this$state3.copying,
        copyFailed = _this$state3.copyFailed;
      if (copyFailed) return 'Copy failed, please try again';
      if (copying) return 'Copied!';
      return defaultLabel;
    }
  }, {
    key: "renderSimpleShare",
    value: function renderSimpleShare() {
      var _this4 = this;
      var _this$props2 = this.props,
        idKey = _this$props2.idKey,
        buttonStyles = _this$props2.buttonStyles,
        triggerText = _this$props2.triggerText,
        triggerType = _this$props2.triggerType;
      var _this$state4 = this.state,
        copying = _this$state4.copying,
        copyFailed = _this$state4.copyFailed;
      var label = this.copyLabel(triggerText);
      var className = "copy-link-simple ".concat(copying ? 'copy-link-simple--copied' : '', " ").concat(copyFailed ? 'copy-link-simple--failed' : '');
      var content = /*#__PURE__*/React.createElement(React.Fragment, null, copying && /*#__PURE__*/React.createElement("i", {
        className: "fa fa-check"
      }), ' ', label);
      if (triggerType === 'link') {
        return /*#__PURE__*/React.createElement("a", {
          className: "modal-anchor-trigger ".concat(buttonStyles, " ").concat(className),
          role: "button",
          tabIndex: 0,
          id: "".concat(idKey, "-link"),
          onClick: function onClick(e) {
            e.preventDefault();
            e.stopPropagation();
            _this4.handleGenerate(_this4.handleCopy);
          },
          onKeyDown: function onKeyDown(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              e.stopPropagation();
              _this4.handleGenerate(_this4.handleCopy);
            }
          }
        }, content);
      }
      return /*#__PURE__*/React.createElement(Button, {
        variant: buttonStyles,
        className: className,
        id: "".concat(idKey, "-button"),
        onClick: function onClick() {
          return _this4.handleGenerate(_this4.handleCopy);
        }
      }, content);
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      var _this$props3 = this.props,
        triggerType = _this$props3.triggerType,
        triggerText = _this$props3.triggerText,
        submitButtonText = _this$props3.submitButtonText,
        idKey = _this$props3.idKey,
        resourceType = _this$props3.resourceType,
        buttonStyles = _this$props3.buttonStyles,
        sourceOptions = _this$props3.sourceOptions,
        recipientOptions = _this$props3.recipientOptions,
        forceModal = _this$props3.forceModal,
        stopPropagation = _this$props3.stopPropagation;
      var _this$state5 = this.state,
        source = _this$state5.source,
        skipScreening = _this$state5.skipScreening,
        copying = _this$state5.copying,
        copyFailed = _this$state5.copyFailed,
        recipient = _this$state5.recipient;
      if (recipientOptions.length === 1 && !forceModal) {
        return this.renderSimpleShare();
      }
      return /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerType: triggerType,
        triggerText: triggerText,
        buttonStyles: buttonStyles,
        submitButtonText: submitButtonText,
        showFooter: false,
        idKey: idKey,
        dialogClassName: "share-resource-modal",
        stopPropagation: stopPropagation
      }, /*#__PURE__*/React.createElement("div", {
        className: "share-resource-modal-body style-guide"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-3"
      }, "Choose the right options to get a shareable link."), /*#__PURE__*/React.createElement("div", {
        className: "rep-choices mb-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "body-text-2"
      }, "Who receives this link?"), /*#__PURE__*/React.createElement(Select, {
        classNamePrefix: "recipient-type",
        options: recipientOptions,
        value: recipient || recipientOptions[0],
        onChange: function onChange(newSelection) {
          return _this5.setState({
            recipient: newSelection
          }, _this5.getUrl);
        },
        styles: _objectSpread({}, dropdownStyleUtils),
        components: {
          DropdownIndicator: DropdownIndicator,
          IndicatorSeparator: function IndicatorSeparator() {
            return null;
          }
        }
      })), recipient.value === 'consultant' && [/*#__PURE__*/React.createElement("div", {
        key: "source-selection",
        className: "rep-choices mb-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "body-text-2"
      }, "How did you find the candidate(s)?"), /*#__PURE__*/React.createElement(Select, {
        classNamePrefix: "sources-dropdown",
        options: sourceOptions,
        placeholder: "Select source",
        value: source,
        onChange: function onChange(newSelection) {
          return _this5.setState({
            source: newSelection
          });
        },
        styles: _objectSpread({}, dropdownStyleUtils),
        components: {
          DropdownIndicator: DropdownIndicator,
          IndicatorSeparator: function IndicatorSeparator() {
            return null;
          }
        }
      })), /*#__PURE__*/React.createElement("div", {
        key: "screening-option",
        className: "rep-choices mb-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "body-text-2"
      }, "Do you want to skip application screening?"), /*#__PURE__*/React.createElement("label", {
        htmlFor: "skip-application",
        className: "custom-checkbox-container body-text-2",
        onClick: this.handleToggleScreening
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "agree-checkbox",
        checked: skipScreening
      }), /*#__PURE__*/React.createElement("span", {
        className: "checkmark"
      }), /*#__PURE__*/React.createElement("span", {
        className: "skip-application-label"
      }, "Yes, skip application screening. I only want proposals from the consultant(s) who get this link.")))], /*#__PURE__*/React.createElement("div", {
        className: "copy-buttons-footer centered"
      }, /*#__PURE__*/React.createElement(Button, {
        className: "copy-link ".concat(copying ? 'copy-link--copied' : '', " ").concat(copyFailed ? 'copy-link--failed' : '', " copy-link-share"),
        disabled: this.linkIsDisabled(),
        id: "copy-link-share-".concat(resourceType.toLowerCase()),
        onClick: function onClick() {
          return _this5.handleGenerate(_this5.handleCopy);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "link-image"
      }, /*#__PURE__*/React.createElement("img", {
        src: copyLinkImg,
        alt: "Copy Share Link"
      })), /*#__PURE__*/React.createElement("div", {
        className: "link-text"
      }, this.copyLabel('Copy link'))))));
    }
  }]);
}(Component);
ShareResource.propTypes = {
  triggerText: PropTypes.string,
  submitButtonText: PropTypes.string,
  idKey: PropTypes.string,
  resourceType: PropTypes.string,
  buttonStyles: PropTypes.string,
  triggerType: PropTypes.string,
  sourceOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  recipientOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  forceModal: PropTypes.bool,
  stopPropagation: PropTypes.bool,
  generateUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  resourceId: PropTypes.string.isRequired
};
ShareResource.defaultProps = {
  triggerType: 'button',
  triggerText: 'Share Resource',
  submitButtonText: 'Generate Link',
  idKey: '',
  resourceType: 'project',
  buttonStyles: 'default',
  forceModal: false,
  stopPropagation: false
};
export default ShareResource;